import React from 'react';
import config from '../../../services/config.json';

import './../../Tarh/TarhDars/TarhDar.css';
import { useContext } from 'react';
import SimpleContext from '../../context/SimpleContext';

const SimpleTarhs = ({IMG, DiscountPercent, description, Title, Az, Ta}) => {
    const context = useContext(SimpleContext)


    let styleee = context.style
    if (context.number>=Az && context.number<=Ta) {
        styleee = "TarhNamePlaceSelected"
    }
    
    return (  
        <div className="tarhha">
            <div className="imagePlace" >

                <img src={`${config.DiscountImage}/${IMG}`} alt="tarh" className="tarhImg"/>
                <p className="">%{(DiscountPercent)/1}<br/>تخفیف</p>
                
            </div>

            <div className={styleee}>
                
                <p>{description}</p>
                <hr className="hr"/>
                <p>{Title}</p>
                
            </div>

        </div>
    );
}
 
export default SimpleTarhs;